export default {
  allLegends: [],
  activeLegends: []
}
